// Lib
import { useEffect, useRef } from 'react';
import { isEmpty, first } from 'lodash/fp';
import { STROKE_SIZES } from '../../drawingEditorConstants';

const useDrawingEditorUpdateToolbarOnSelection = ({
    isMarqueeSelectMode,
    paths,
    selectedPathIdsMap,
    setStrokeSizeState,
    setStrokeColorState,
    canvasScale,
}) => {
    const hasSelectionsRef = useRef(false);

    useEffect(() => {
        if (isMarqueeSelectMode) return;

        const alreadyHadSelections = hasSelectionsRef.current;

        hasSelectionsRef.current = !isEmpty(selectedPathIdsMap);

        const selectedIds = Object.keys(selectedPathIdsMap);
        const shouldUpdateTools = hasSelectionsRef.current && (!alreadyHadSelections || selectedIds.length === 1);

        if (!shouldUpdateTools) return;

        const firstSelectedId = first(selectedIds);
        const path = paths.find((p) => p.id === firstSelectedId);

        if (!path) return;

        const { color, size } = path;
        const safeCanvasScale = Number.isFinite(canvasScale) && canvasScale > 0 ? canvasScale : 1;
        const normalizedPathSize = Number.isFinite(size) && size > 0 ? size : STROKE_SIZES.MEDIUM / safeCanvasScale;
        const toolbarStrokeSize = Math.round(normalizedPathSize * safeCanvasScale);

        setStrokeSizeState(toolbarStrokeSize);

        if (color) setStrokeColorState(color);
    }, [selectedPathIdsMap, isMarqueeSelectMode]);
};

export default useDrawingEditorUpdateToolbarOnSelection;
